import { connect } from 'react-redux'

import { ItemPicker } from '@components/order/edit/sections'

import services from '@services'
import coordinators from '@coordinators'
import presenters from '@presenters'

const mapStateToProps = (state) => {
  const { order } = state
  const orderId = order && order.id

  return {
    orderId,
  }
}
const mapDispatchToProps = () => {
  const { ChefService, OrderService, RestService } = services
  const {
    // AsyncLoadAddOnChefs,
    AsyncLoadChefs,
    AsyncLoadConcepts,
    AsyncLoadCateringMenuItems,
    AsyncLoadServiceItems,
    AsyncLoadSnackPacks,
    AsyncLoadVirtualItems,
    AsyncLoadVirtualKits,
  } = coordinators
  const {
    pResponseChefs,
    pResponseAllChefConcepts,
    pResponseAllChefMenuItems,
    // pResponseAllServiceItems,
    pResponseServiceItems,
    pResponseSnackPacks,
    pResponseVirtualItems,
    pResponseVirtualKits,
    pRequestLoadConcepts,
  } = presenters.Api

  const { filterMenuItems } = OrderService
  const loadCateringMenuItems = AsyncLoadCateringMenuItems({
    RestService,
    pResponseAllChefMenuItems,
  })
  // const loadAddOnChefs = AsyncLoadAddOnChefs({ ChefService, RestService, pResponseChefs })
  const loadChefs = AsyncLoadChefs({
    ChefService,
    OrderService,
    RestService,
    pResponseChefs,
  })
  const loadConcepts = AsyncLoadConcepts({
    RestService,
    pResponseAllChefConcepts,
    pRequestLoadConcepts,
  })
  // const loadServiceItems = AsyncLoadServiceItems({ RestService, pResponseAllServiceItems })
  const loadServiceItems = AsyncLoadServiceItems({
    RestService,
    pResponseServiceItems,
  })
  const loadSnackPacks = AsyncLoadSnackPacks({
    RestService,
    pResponseSnackPacks,
  })
  const loadVirtualItems = AsyncLoadVirtualItems({
    RestService,
    pResponseVirtualItems,
  })
  const loadVirtualKits = AsyncLoadVirtualKits({
    RestService,
    pResponseVirtualKits,
  })

  return {
    filterMenuItems,
    // loadAddOnChefs,
    loadCateringMenuItems,
    loadChefs,
    loadConcepts,
    loadServiceItems,
    loadSnackPacks,
    loadVirtualItems,
    loadVirtualKits,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemPicker)
